import httpClient from '@common/api/httpClient';
import { type UploadedFile } from '@common/types/api';

export async function sendFeedback(
  topic: string,
  description: string,
  uploadedFiles: UploadedFile[] = [],
): Promise<boolean> {
  try {
    await httpClient.post(
      '/rest/v1/Feedback/form',
      { topic, description, uploadedFiles },
    );
    return true;
  } catch {
    return false;
  }
}

export async function uploadFeedbackFiles(files: File[]): Promise<UploadedFile[] | undefined> {
  try {
    const formData = new FormData();

    files.forEach((file: File) => formData.append('files', file));

    const { data } = await httpClient.post(
      '/rest/v1/Feedback/FileUpload',
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      },
    );

    return data;
  } catch {
    return undefined;
  }
}
